import React, { Suspense, useRef } from 'react'
import { useRouter } from 'next/router'
// Sanity
import { getClient } from '../client'
import { propsSanity, groqSanityPageQuery } from '../lib/libFunctions'

// Styles
import { base } from '../styles/base/_allBase.styles'
const {
  GridItem_HeaderSection,
  GridContainer_Page_Layout,
  Page_Main_Grid_Container,
} = base
// Components
import SEO from '../components/seo-head/seo-head'
import SectionOne from '../components/section-one/section-one.jsx'
import { Header } from '../components/header/header'
import { Footer } from '../components/footer/footer.component.jsx'
import AccommodationGridSection from '../components/accommodationGridSection/AccommodationGridSection'

function Home(props) {
  const sectionOneRef = useRef()
  const router = useRouter()

  const {
    header,
    boniDay,
    roomsCarousel,
    headerTwoColumnText,
    dragSlider,
    BoniBeachRestaurant,
    BoniRooftop,
    PageContactSection,
    videoHeader,
    featuredTopics,
    whereToStay,
  } = props.data.data
  const { seo } = props.data

  return (
    <GridContainer_Page_Layout>
      <SEO seo={seo} router={router} header={header} />
      <GridItem_HeaderSection>
        <header ref={sectionOneRef}>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <Suspense fallback={<div>Loading...</div>}>
            <SectionOne header={header} />
            <AccommodationGridSection
              module={whereToStay}
              accommodations={whereToStay?.accommodations || []}
            />
            {/* <FeaturedTopicsSection topics={featuredTopics?.topics || []} /> */}
            {/* <ReviewsSection reviews={filteredReviews} /> */}
            {/* <DragSliderSection data={dragSlider} /> */}
            {/* <CarouselBoniDay imageArray={boniDay.items} /> */}
          </Suspense>
          {/* <SectionCarousel array={roomsCarousel.array} /> */}
          {/* <HeaderTwoColumGrid data={headerTwoColumnText} /> */}
          <Suspense fallback={<div>Loading...</div>}>
            {/* <HorizontalScroll data={BoniBeachRestaurant} direction="left" /> */}
            {/* <HorizontalScroll data={BoniRooftop} direction="right" /> */}
          </Suspense>
          <Footer
          // toTopRef={sectionOneRef}
          // data={PageContactSection.content[0]}
          // data2={PageContactSection}
          />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}

export async function getServerSideProps() {
  const query = groqSanityPageQuery('things-to-do')
  const data = await getClient().fetch(query, {})

  return {
    props: {
      data: propsSanity(data),
    },
  }
}

export default Home
